module.exports = __webpack_public_path__ + "static/media/t .9766fef4.svg";